var resizeObservers = [];
export { resizeObservers };



//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
// module id = 31
// module chunks = 0